import { render, staticRenderFns } from "./sidebarItem2.vue?vue&type=template&id=de1d0354&scoped=true&"
import script from "./sidebarItem2.vue?vue&type=script&lang=js&"
export * from "./sidebarItem2.vue?vue&type=script&lang=js&"
import style0 from "./sidebarItem2.vue?vue&type=style&index=0&id=de1d0354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1d0354",
  null
  
)

export default component.exports